import React, { useState } from "react";
import { ChevronLeftIcon, CheckIcon } from "@heroicons/react/24/outline";

function MessageDetails({
  goBack,
  selectedConversation,
  setView,
  setupDetails,
}) {
  const [activeTab, setActiveTab] = useState("Details");

  return (
    <div className="flex flex-col h-full mb-0 mt-0 overflow-hidden">
      <div className="flex items-center justify-start z-10">
        <button
          onClick={goBack}
          className="dexkor-ticket-back-button p-1 h-7 w-7 rounded-md mr-2 mb-5 z-10"
        >
          <ChevronLeftIcon className="h-5 cursor-pointer" />
        </button>
        <div className="text-left">
          <p className="font-bold text-white">
            {selectedConversation.ticketId.ticketNumber}
          </p>
          {selectedConversation && (
            <div className="flex items-center justify-start cursor-pointer z-10 text-sm">
              <div className="mr-2 mb-1 text-white">
                Status: <span>{selectedConversation.ticketId.status}</span>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="flex p-2 gap-x-6">
        {/* Discussion Tab */}
        <div
          style={{
            color:
              activeTab === "Discussion" &&
              setupDetails?.widgetCustomizations?.primaryColor,
          }}
          className={`text-sm cursor-pointer ${
            activeTab === "Discussion" ? " font-semibold" : "text-gray-600"
          }`}
          onClick={() => {
            setActiveTab("Discussion");
            setView("message");
          }}
        >
          Discussion
        </div>

        {/* Details Tab */}
        <div
          style={{
            color:
              activeTab === "Details" &&
              setupDetails?.widgetCustomizations?.primaryColor,
          }}
          className={`text-sm cursor-pointer ${
            activeTab === "Details" ? " font-semibold" : "text-gray-600"
          }`}
          onClick={() => {
            setActiveTab("Details");
            setView("MessageDetails");
          }}
        >
          Details
        </div>
      </div>
      <hr className="mt-0 border-t border-gray-300"></hr>
      <div className="flex items-center p-2 mt-3">
        <div className="font-bold text-start">
          SLA Breaching for Closed Tickets
        </div>
        <CheckIcon
          className="h-6 w-6 bg-green-500 text-white rounded-full p-1 ml-auto"
          strokeWidth={3}
        />
      </div>
      <div className="text-sm text-start p-2">
        Lorem Ipsum is simply dummy text of the printing and typesetting
        industry. Lorem Ipsum has been the industry's standard dummy text ever
        since the 1500s, when an unknown printer took a galley of type and
        scrambled it to make a type specimen book. It has survived not only five
        centuries, but also the leap into electronic typesetting, remaining
        essentially unchanged.
      </div>
    </div>
  );
}

export default MessageDetails;
